import { colors } from 'ui/theme/colors';
import { getColor } from 'ui/icons/utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Asterisk16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 12 12" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.62807 1.07722C6.62807 0.730384 6.34691 0.449219 6.00007 0.449219C5.65324 0.449219 5.37207 0.730384 5.37207 1.07722V4.48264L2.96417 2.07458C2.71893 1.82932 2.3213 1.82931 2.07604 2.07455C1.83078 2.31979 1.83077 2.71742 2.07601 2.96267L4.48427 5.37109H1.0782C0.73136 5.37109 0.450195 5.65226 0.450195 5.99909C0.450195 6.34593 0.73136 6.62709 1.0782 6.62709H4.4838L2.07601 9.03505C1.83077 9.2803 1.83078 9.67793 2.07604 9.92317C2.3213 10.1684 2.71893 10.1684 2.96417 9.92314L5.37207 7.51508V10.921C5.37207 11.2678 5.65324 11.549 6.00007 11.549C6.34691 11.549 6.62807 11.2678 6.62807 10.921V7.51504L9.03601 9.92314C9.28125 10.1684 9.67888 10.1684 9.92414 9.92317C10.1694 9.67793 10.1694 9.2803 9.92417 9.03505L7.51638 6.62709H10.9219C11.2688 6.62709 11.5499 6.34593 11.5499 5.99909C11.5499 5.65226 11.2688 5.37109 10.9219 5.37109H7.51591L9.92417 2.96267C10.1694 2.71742 10.1694 2.31979 9.92414 2.07455C9.67888 1.82931 9.28125 1.82932 9.03601 2.07458L6.62807 4.48268V1.07722Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
